<template>
    <v-container>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate
                                 size="64"></v-progress-circular>
        </v-overlay>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="primary">
                        <v-toolbar-title style="color: white;">
                            Recibir Documentación de Reporte
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon color="white">mdi-file-document-multiple-outline</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="6" offset-md="3">
                                <v-list subheader three-line>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title style="color: black !important;">Reporte(s):</v-list-item-title>
                                            <v-card>

                                                <v-data-table :headers="headers2"
                                                              hide-default-footer
                                                              :items="docto">
                                                </v-data-table>
                                            </v-card>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title style="color: black !important;">Fecha:</v-list-item-title>
                                            <v-menu ref="menu1"
                                                    v-model="menu1"
                                                    :close-on-content-click="false"
                                                    transition="scale-transition"
                                                    offset-y
                                                    max-width="290px"
                                                    min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="dateFormatted"
                                                                  outlined
                                                                  readonly
                                                                  v-bind="attrs"
                                                                  @blur="date = parseDate(dateFormatted)"
                                                                  v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="date"
                                                               locale="es-mx"
                                                               :max="maxfecha"
                                                               :min="mindate"
                                                               @input="menu1 = false"></v-date-picker>
                                            </v-menu>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title style="color: black !important;">Observaciones:</v-list-item-title>
                                            <v-form ref="frm" v-model="valid" lazy-validation>
                                                <v-textarea :counter="500"
                                                            :rules="rulestextarea"
                                                            outlined
                                                            v-model="comentarios"
                                                            required
                                                            name="input-7-4"></v-textarea>
                                            </v-form>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <v-btn class="ma-2"
                                       color="primary" @click="Guardar()">
                                    Guardar
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                                <v-btn class="ma-2" @click="Limpiar()">
                                    Limpiar
                                </v-btn>
                                <v-btn class="ma-2" color="error" @click="Regresar()">
                                    Regresar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
    
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import moment from "moment";
    import servicio from '@/services/TramitePago/TramitePago.Service.js'

    export default {
        title() {
            return this.$route.meta.title
        },
        data: vm => ({
            valid: true,
            maxfecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
            menu1: false,
            comentarios: '',
            rulestextarea: [
                v => !!v || 'Campo requerido',
                v => {
                    if (v == null) {
                        return true
                    }
                    else {
                        if (v.length < 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > 500) {
                            return 'Máximo 500 Carácteres'
                        }
                        else
                            return true
                    }
                },
            ],
            headers2: [
                { text: 'Reporte', value: 'nrreporte', class: 'text title' },
                    { text: 'Clave', value: 'prclave', class: 'text title' },
                    { text: 'Nombre', value: 'prnombre', class: 'text title' },
                    { text: 'Asistencia', value: 'Asistencia', class: "text title" },
                    { text: 'Fecha del Reporte', value: 'svfhreporte', class: "text title" },        
            ],
            mindate: '',
            npid: 0,
            overlay: false,
        }),
        props: ['docto', 'permiso'],
        computed: {
            ...mapState([
                "domain",
                "informationPage",
                "paginacion",
                "permission",
                "user"
            ]),
            computedDateFormatted() {
                return this.formatDate(this.date)
            },
        },
        watch: {
            date(val) {
                this.dateFormatted = this.formatDate(this.date)
            },
            overlay(val) {
                val && setTimeout(() => {
                    this.overlay = false
                }, 2000)
            },
        },
        methods: {
            formatDate(date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            parseDate(date) {
                if (!date) return null

                const [day, month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            Guardar() {
                this.comentarios = this.comentarios.trim();
                this.comentarios = this.comentarios.replace(/\s*$/, "");
                if (this.$refs.frm.validate() && this.comentarios.length >= 12) {
                    let formData = new FormData();
                    var reportes = '';
                    this.docto.forEach(function (data) {
                            reportes += data.nrreporte + '/';
                    });
                    formData.append("reportes", reportes);
                    formData.append("fecha", this.date);
                    formData.append("obs", this.comentarios);
                    formData.append("prclave", this.permiso);
                    this.$swal({
                        title: "Guardando, espere un momento....",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                    this.$swal.showLoading();
                    servicio.GuardarRecibirDocto(this, formData).then(data => {
                        if (data[0].success == "true") {
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Éxito",
                                text: "Los datos se guardaron correctamente",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: true,
                                timer: 2000,
                                confirmButtonText: "Ok!",
                            }).then(() => {
                                if (this.permiso == 338)
                                    this.$router.push({ name: `DoctoTramite` });
                                else
                                    this.$router.push({ name: `DoctoPendienteRecibir` });
                            });
                        }
                        else {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: "Error",
                                text: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: true,
                                confirmButtonText: "Ok!",
                            });
                        }
                    });
                }
            },
            Regresar() {
                if (this.permiso == 338)
                    this.$router.push({ name: `DoctoTramite` });
                else
                    this.$router.push({ name: `DoctoPendienteRecibir` });
            },
            Limpiar() {
                this.comentarios = '';
                this.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            },
            obtenerfecha() {
                let formdata = new FormData();
                formdata.append("npid", this.npid);
                servicio.ObtenerFecha(this, formdata).then(data => {
                    this.mindate = this.parseDate(data[0].npfhenvio);
                });
            },
        },
        mounted() {
            if (this.docto === undefined) {
                this.$router.go(-1);
            }
            else {
                this.npid = Math.min(...this.docto.map(x => parseInt(x.npid)));

                this.obtenerfecha();
            }
            this.overlay = true;
        }
    }
</script>